var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center my-3 d-print-none",staticStyle:{"height":"2rem"}},[_c('div',{staticClass:"fa fa-fw fa-circle-notch fa-2x fa-spin"})])
}]

export { render, staticRenderFns }